import React, { useState, useEffect, useContext, useRef, createRef } from "react";
import Button from "@mui/material/Button";
import Context from "../../../../context/Context";
import { Modal } from "react-bootstrap";
import './styles.css'


export const AnaliseModalObs = ({
  showObs,
  item,
  putAnalisePeca,
  setShowObs,
  itemkey,
  Vagaokey
}) => {

  const [obs, setObs] = useState("");

  const {
  } = useContext(Context);

  useEffect(() => {
  }, []);

  return (
    <>
      <Modal onHide={() => { }} size="lg" show={showObs}>
        <Modal.Header>
          <h3 className="title_tables" >
            {`APONTAMENTO DE ANÁLISE PARA ORDEM: ${item.ordem_Serial}`}
          </h3>
        </Modal.Header>

        <Modal.Body className="my-3">
          <textarea
            className="text-area-analise-modal"
            placeholder="OBSERVAÇÃO"
            onChange={(e) => setObs(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer className="p-2">

          <Button
            className="me-2"
            variant="contained"
            onClick={() => {
              setShowObs(false)
            }}
          >
            CANCELAR
          </Button>

          <Button
            variant="contained"
            onClick={() => putAnalisePeca(item, obs, Vagaokey, itemkey)}
          >
            APONTAR
          </Button>



        </Modal.Footer>
      </Modal>

    </>
  );

}
